module.exports = __webpack_public_path__ + "static/media/place.96333e4b.svg";